var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"d-flex align-items-end logo-container",class:_vm.$data.staticClass || ''},'div',_vm.$data.attrs,false),[_c('img',{attrs:{"src":"logo.svg","alt":"Logo","width":"50","height":"50"}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-body ml-2 text-nowrap"},[_c('span',[_vm._v("TouHou Music ")]),_c('span',{staticClass:"text-muted"},[_vm._v("😊")])])
}]

export { render, staticRenderFns }